module.exports = {
    STATUS_UPDATE_EMAIL_TEMPLATE: "Are you sure you want to {status} this Email Template?",
    STATUS_UPDATE_EMAIL_TEMPLATE_ALL: "Are you sure you want to {status} Email Template?",
}